export enum IntegratorStatus {
  InReview = 'In Review',
  Approved = 'Approved',
  Declined = 'Declined',
  NDARequested = 'NDARequested',
  Revoked = 'Revoked',
}

export enum CompanyStatus {
  IN_REVIEW = 'IN_REVIEW',
  APPROVED = 'APPROVED',
  DECLINED = 'DECLINED',
  NDA_REQUESTED = 'NDA_REQUESTED',
  REVOKED = 'REVOKED',
}
